import { Component, OnInit, Input } from '@angular/core';

import { AuthService, AdminService, MessagingService, SessionService, ModalService, DialogService } from "../../../services";
import { DialogComponent } from '../../common/dialog/dialog.component';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'sn-usci-header',
  templateUrl: './usci-header.component.html',
  styleUrls: ['./usci-header.component.css']
})
export class UsciHeaderComponent implements HeaderComponent, OnInit {
  @Input() data: any;

  constructor(
    public authService: AuthService,
    public modalService: ModalService,
    public dialogService: DialogService
  ) { }

  ngOnInit() {
  }

  logOff() {
    this.authService.logoff();
  }

  test() {
    //var title = "Campaign Request Submitted: " + 134;
    var msgList = [];
    msgList.push("Your Campaign Request (ID: "+123+") has been submitted.");
    msgList.push("");
    msgList.push("Please retain this ID in the event that a change is required to this campaign request.");
    this.modalService.openContent(
      DialogComponent,
      { dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
      { backdrop: 'static', keyboard: false }
    ).result.then(
      (result) => { },
      (reason) => { }
    );          
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-campaign/usci-header/usci-header.component.ts